import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from '@services/auth/auth.service';
import { createPassword } from '@classes/auth/createPassword';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  createPasswordForm: UntypedFormGroup;
  token: string;
  userId: string;


  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute,
    private jwtHelperSrv: JwtHelperService

  ) { }

  ngOnInit(): void {
    this.initForm();

    this.route.queryParams.subscribe(params => {
      this.token = params.token;
      this.userId = params.id;
    });
  }
  onSubmit(): void {


    const createPassword: createPassword = {
      password: this.authService.cryptString(this.createPasswordForm.get('password').value)
    };
    if (this.createPasswordForm.get('password').value === this.createPasswordForm.get('confirmPassword').value) {


      this.authService.resetPassword(this.userId, this.token, this.createPasswordForm.get('password').value).subscribe(() => { }, error => {

      });

    }


  }

  private initForm(): void {
    this.createPasswordForm = this.formBuilder.group({

      password: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    })
  }



}
